import { Icon } from "@/react/components/shared/Icon";
import { abbreviateNumber } from "@/react/helpers/number";
import type { TopPerformingPost } from "@circle-react/apps/EoyRecapApp/types";

interface TopPerformingPostCardProps {
  post: TopPerformingPost;
}

export const TopPerformingPostCard = ({ post }: TopPerformingPostCardProps) => {
  if (!post) return null;

  return (
    <div className="relative w-full max-w-md pb-4">
      <div className="absolute inset-0 bg-[rgba(67,43,73,0.63)] rounded-2xl translate-y-px" />
      <div className="absolute inset-0 bg-[rgba(67,53,71,0.31)] rounded-2xl translate-y-4" />

      <div className="relative bg-[#49335A] rounded-2xl p-6 shadow-2xl z-10 flex flex-col gap-5">
        <h3 className="text-white text-base font-semibold leading-tight text-balance line-clamp-3">
          {post.display_title}
        </h3>

        <div className="bg-[rgba(67,43,73,0.63)] h-20 w-full rounded-2xl" />

        <div className="flex items-center gap-4 text-white">
          <div className="flex items-center gap-1">
            <Icon type="24-heart-outline" className="size-4 text-white" />
            <span className="text-base">{abbreviateNumber(post.likes)}</span>
          </div>

          <div className="flex items-center gap-1">
            <Icon type="24-comment" className="size-4 text-white" />
            <span className="text-base">{abbreviateNumber(post.comments)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
